import { key } from 'core-ts-types';
import { IProgression } from 'utility-js-progression';

export class TransferCreditsProgressState {
  private lastVisitedState = 0;

  constructor(public ngTransferCreditsProgression: IProgression) {}

  getLastVisitedState(): key {
    return this.ngTransferCreditsProgression.queryItem(this.lastVisitedState).key;
  }

  setLastVisitedState(stateKey: key): void {
    const key = this.ngTransferCreditsProgression.queryIndexByKey(stateKey);
    if (key < 0) {
      return;
    }
    this.lastVisitedState = key;
  }

  clear(): void {
    this.lastVisitedState = 0;
  }
}

angular.module('capability-ng-transfer').service('ngTransferCreditsProgressState', TransferCreditsProgressState);



// WEBPACK FOOTER //
// ./app/lib/transfer/progression/transfer_credits_progress_state.ts